class DragScroll {
  constructor(container) {
    this.container = container;
    this.pushed = false;
    this.lastClientX = 0;
    //this.lastClientY = 0; -> Uniquement scroll horizontal
    this.hasMoved = false;
    this.raf = null;

    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onClick = this.onClick.bind(this);

    this.attach();
  }

  attach() {
    this.container.addEventListener('mousedown', this.onMouseDown);
    window.addEventListener('mouseup', this.onMouseUp, { passive: true });
    window.addEventListener('mousemove', this.onMouseMove, { passive: true });
    this.container.addEventListener('click', this.onClick, true); // capture phase
  }

  detach() {
    this.container.removeEventListener('mousedown', this.onMouseDown);
    window.removeEventListener('mouseup', this.onMouseUp, { passive: true });
    window.removeEventListener('mousemove', this.onMouseMove, { passive: true });
    this.container.removeEventListener('click', this.onClick, true);
  }

  onMouseDown(e) {
    if (
      this.container.hasAttribute('nochilddrag') &&
      e.target !== this.container
    ) return;

    this.pushed = true;
    this.hasMoved = false;
    this.lastClientX = e.clientX;
    //this.lastClientY = e.clientY; -> Uniquement scroll horizontal

    this.container.classList.add('dragging');
    e.preventDefault();
  }

  onMouseUp() {
    this.pushed = false;
    this.container.classList.remove('dragging');
  }

  onMouseMove(e) {
    if (!this.pushed) return;

    const dx = e.clientX - this.lastClientX;
    const dy = e.clientY - this.lastClientY;

    //if (Math.abs(dx) > 5 || Math.abs(dy) > 5) { -> Uniquement scroll horizontal
    if (Math.abs(dx) > 5) {
      this.hasMoved = true;
    }

    this.lastClientX = e.clientX;
    //this.lastClientY = e.clientY; -> Uniquement scroll horizontal

    // Lissage via rAF
    if (!this.raf) {
      this.raf = requestAnimationFrame(() => {
        this.container.scrollLeft -= dx;
        //this.container.scrollTop -= dy; -> Uniquement scroll horizontal
        this.raf = null;
      });
    }
  }

  onClick(e) {
    if (this.hasMoved) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.hasMoved = false;
    }
  }
}

// Init pour dragscroll
const initDragScroll = (root) => {
  root.querySelectorAll('.dragscroll').forEach(el => {
    if ('dragscrollInit' in el.dataset) return;
    el.dataset.dragscrollInit = 'true';
    new DragScroll(el);
  });
};

window.addEventListener('load', () => initDragScroll(document));

// Init pour les sections différées du theme (contenu injecté après coup)
document.querySelectorAll('recently-viewed-products, product-recommendations').forEach(host => {
  new MutationObserver(() => initDragScroll(host))
    .observe(host, { childList: true, subtree: true });
});